export var getTextDecoration = function getTextDecoration(_ref) {
  var appearance = _ref.appearance,
    renderAs = _ref.renderAs,
    state = _ref.state;
  // necessary for links that render to look like buttons
  if (appearance !== "link" && state.isHover) return "none";

  // handles links that render as links
  return renderAs === "a" && !state.isDisabled && (state.isActive || state.isHover || state.isFocus) ? "underline" : "none";
};
//# sourceMappingURL=getButtonTextDecoration.js.map